import { __assign, __rest } from "tslib";
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { debounce } from '../../../library/helpers';
import { SpinnerIcon } from '../../../design/assets/spinner/spinner.icon';
import { SearchIcon } from '../../../design';
import classNames from 'classnames';
export var SearchBar = React.forwardRef(function (_a, outerRef) {
    var 
    // html props
    id = _a.id, name = _a.name, disabled = _a.disabled, 
    // value,
    onInput = _a.onInput, 
    // custom props
    label = _a.label, large = _a.large, responsive = _a.responsive, loading = _a.loading, props = __rest(_a, ["id", "name", "disabled", "onInput", "label", "large", "responsive", "loading"]);
    var cleansedProps = __assign(__assign({}, props), { 
        // html props
        id: id !== null && id !== void 0 ? id : label, name: name !== null && name !== void 0 ? name : label, disabled: disabled, 
        // custom props
        label: undefined, validation: undefined, large: undefined, responsive: undefined, loading: undefined });
    var innerRef = useRef(null);
    useImperativeHandle(outerRef, function () { return innerRef.current; }, []);
    var _b = useState(''), value = _b[0], setValue = _b[1];
    // useEffect(() => {
    //   setValues(value as string);
    // }, [value]);
    useEffect(function () {
        setValues(!!props.value ? props.value : props.defaultValue);
    }, [props.defaultValue, props.value]);
    function setValues(temp) {
        if (value !== temp)
            setValue(temp !== null && temp !== void 0 ? temp : '');
        if (!!innerRef.current && innerRef.current.value !== temp)
            innerRef.current.value = temp !== null && temp !== void 0 ? temp : '';
    }
    function onInputHandler(event) {
        var temp = event.currentTarget.value.toString();
        debounce(function () {
            onInput(event);
            setValues(temp);
        }, 300);
    }
    return (React.createElement("div", { className: classNames('inputWrapper text prefix', {
            populated: !!value,
            disabled: disabled,
            large: large,
            responsive: responsive,
            suffix: loading,
        }) },
        React.createElement("div", { className: classNames('inputIcon prefix', { large: large }) },
            React.createElement(SearchIcon, { tone: disabled ? 'default' : 'secondary' })),
        React.createElement("label", { htmlFor: id !== null && id !== void 0 ? id : label, className: "inputLabel inputText" }, label),
        React.createElement("input", __assign({}, cleansedProps, { ref: innerRef, className: "inputTriggerWrapper inputTrigger inputText", type: "search", autoComplete: "xyz123" // Chrome ignores "off" and "false"
            , onInput: onInputHandler })),
        loading && (React.createElement("div", { className: classNames('inputIcon suffix', { large: large }) },
            React.createElement(SpinnerIcon, null)))));
});
SearchBar.displayName = 'SearchBar';
export default SearchBar;
